import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';

import { PasswordFormService } from './password-form.service';
import { PasswordStrengthSettingsModel } from './password-strength-settings.model';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-password-form-control',
    styleUrls: ['./password-form-control.scss'],
    templateUrl: './password-form-control.component.html',
    standalone: false
})
export class PasswordFormControlComponent implements OnInit {
   form: UntypedFormGroup;

   hidePassword = true;

   hideConfirmPassword = true;

   passwordStrengthRules: PasswordStrengthSettingsModel | undefined;

   constructor(private store: Store, private passwordFormControlService: PasswordFormService) {
      this.form = this.passwordFormControlService.form;
   }

   ngOnInit() {
      this.passwordStrengthRules = {
         maxConsecutiveCharacters: 2,
         minimumLength: 10,
         minimumNumericCharacters: 1,
         minimumSpecialCharacters: 1,
         minimumUpperCaseCharacters: 1,
      };
      this.passwordFormControlService.setValidationRules(this.passwordStrengthRules);
   }
}
